import { FloorGameActivity } from '@pkg/types/floorGame';

import { TickStatus } from './types';

// At the moment, we cannot stretch the `Pocket` width because
// it will cause the parallelogram angle to distort in relation
// to any adjacent `Ticks`. To mitigate this, we cap the number
// of characters that can render within the `Pocket` to `3`.
// This includes the `+` prefix character.
export const MIN_POCKET_COUNT = 1;
export const MAX_POCKET_COUNT = 99;

export function pocketWithinRange(count = MIN_POCKET_COUNT) {
    const countAboveFloor = Math.max(MIN_POCKET_COUNT, Math.ceil(count));
    return Math.min(countAboveFloor, MAX_POCKET_COUNT);
}

export function activityToTickStatus(activity: FloorGameActivity) {
    if (activity === FloorGameActivity.HighDemand || activity === FloorGameActivity.OnFire) {
        return TickStatus.Positive;
    }

    if (activity === FloorGameActivity.LowDemand) return TickStatus.Negative;

    return TickStatus.Neutral;
}
